// Maps insight-action ids that leave the PAR Intelligence drawer and open the
// full void & refund trend report page, mirroring campaignActions.ts / laborScheduleActions.ts.
//
// Action ids are deterministic and shared between the live (backend-generated)
// and seed (static) insight cards, so a single id → flag is enough to wire both.

const VOID_REFUND_REPORT_ACTION_IDS = new Set<string>(["act_demo_health_review_log"]);

export function opensVoidRefundReport(actionId: string): boolean {
    return VOID_REFUND_REPORT_ACTION_IDS.has(actionId);
}
